import { observable } from 'mobx';

class WebinarStore {
  @observable page = {
    name: '',
    content: '',
    published: false
  };

  @observable mfeToggle = {
    isLoading: false,
    value: false
  };
}

export default new WebinarStore();
